// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rMms","questions":"styles_questions__1RQHJ","footer":"styles_footer__Gqvqu"};